export default {
  App: {
    Title: 'GETFOOD PRO - EL',
    Desc : '',
    Img  : ''
  }
}
